export default {
  setEngagementCategoryTitleRules(state, { categoryType, categories }) {
    state.engagementCategoryTitleRules[categoryType] = categories;
  },
};


